import { useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { CollaborativeAgreementLicenseDetails, getProviderCollaborativeMatchRequests, requestCollaborativePhysicianMatch } from '@uplift/api';
import { BaseSuspenseQueryOpts } from '../baseTypes';


const collaborativeMatchRequestKeys = {
  byProvider: (providerId: string) => [ 'provider', providerId, 'collaborativeMatchRequests' ] as const,
};

export const useProviderCollaborativeMatchRequestsQuery = (providerId: string, opts?: BaseSuspenseQueryOpts) => {
  return useSuspenseQuery({
    queryKey: collaborativeMatchRequestKeys.byProvider(providerId),
    queryFn: async () => getProviderCollaborativeMatchRequests(providerId),
    select: response => response.data.reduce(
      (acc, details) => ({ ...acc, [ details.licenseId ]: details }),
      {} as Record<string, CollaborativeAgreementLicenseDetails>
    ),
    ...opts,
  });
};

export const useRequestCollaborativePhysicianMatchMutation = (providerId: string, licenseId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const response = await requestCollaborativePhysicianMatch(providerId, licenseId);

      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: collaborativeMatchRequestKeys.byProvider(providerId) });
    },
  });
};
